import { WebActionItemService } from './web';
export default WebActionItemService;
